var React = require('react');

function Login (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon_login","data-name":"Icon/login","transform":"translate(-3 -3)"},[React.createElement("path",{"id":"Path_78","data-name":"Path 78","d":"M11.677,14.7a6.4,6.4,0,0,0,3.785,1.228,6.6,6.6,0,0,0,6.462-6.462A6.462,6.462,0,1,0,11.677,14.7Z","transform":"translate(-0.462)","fill":"#e62a2c","key":0}),React.createElement("path",{"id":"Path_79","data-name":"Path 79","d":"M20.686,16.55a8.279,8.279,0,0,1-11.372,0A12.018,12.018,0,0,0,3,27.119a.926.926,0,0,0,.923.923H26.077A.926.926,0,0,0,27,27.119,12.018,12.018,0,0,0,20.686,16.55Z","transform":"translate(0 -1.042)","fill":"#e62a2c","key":1})]));
}

Login.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Login;

Login.default = Login;
